const cache = new Map<string, { value: any; timestamp: number }>()

export async function withMemoryCache<T>(key: string, ttl: number, fetcher: () => Promise<T>): Promise<T> {
  const cachedValue = cache.get(key)
  const now = Date.now()

  if (cachedValue && cachedValue.timestamp + ttl > now) {
    return Promise.resolve(cachedValue.value)
  }

  return fetcher().then((value) => {
    cache.set(key, { value, timestamp: now })
    return value
  })
}
